/*
 * @Date: 2022-06-09 15:06:25
 * @LastEditors: guantingting
 * @LastEditTime: 2023-11-24 10:44:09
 */
// 默认是prd
let environment = 'prd'

// 判断环境
let host = location.host
// sit
if (host.indexOf('m.rv2go.cn') > -1 || host.indexOf('localhost') > -1 || host.indexOf('dev.rv2go.cn') > -1) {
  environment = 'sit';
}
// uat
if (host.indexOf('m-uat.rv2go.cn') > -1) {
  environment = 'uat';
}
// prd
if (host.indexOf('m.rv2go.com') > -1) {
  environment = 'prd';
}

window.env = environment
export const conf = (obj) => obj[environment]

export const AIKAKEY = conf({
  dev: '109',
  sit: '109',
  uat: '109',
  prd: '350'
});

// 2.0接口
export const serverUrl = conf({
  dev: 'https://apptest.rv2go.cn/gateway/',
  sit: 'https://apptest.rv2go.cn/gateway/',
  uat: 'https://apptest-uat.rv2go.cn/gateway/',
  prd: 'https://app.rv2go.com/gateway/'
});

// 1.0接口
export const serverUrlOld = conf({
  dev: 'https://apptest.rv2go.cn/gateway/',
  sit: 'https://apptest.rv2go.cn/gateway/',
  uat: 'https://apptest-uat.rv2go.cn/gateway/',
  prd: 'https://app.rv2go.com/gateway/'
});

// 上传接口
export const uploadUrl = conf({
  dev: 'https://apptest.rv2go.cn/gateway/',
  sit: 'https://apptest.rv2go.cn/gateway/',
  uat: 'https://apptest-uat.rv2go.cn/gateway/',
  prd: 'https://app.rv2go.com/gateway/'
});

/**
 * 支付baseUrl
 */
export const originC2bUrl = conf({
  dev: 'https://c2bt4.maxuscloud.com/xyx',
  sit: 'https://c2bt4.maxuscloud.com/xyx',
  uat: 'https://c2bt4.maxuscloud.com/xyx',
  prd: 'https://c2b.saicmaxus.com/xyx'
});


// WEBPACK FOOTER //
// ./src/api/baseMap.js